import React from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledSpace from "./Space.styles";
import { SpaceProps } from "./Space.types";

const Space = React.forwardRef<HTMLElement>(
	({ children, className, htmlTag, ...props }: SpaceProps, ref) => {
		const block = new BemIt("Space");

		return (
			<StyledSpace
				ref={ref}
				as={htmlTag}
				className={addClass(className).after(block)}
				{...props}
			>
				{children}
			</StyledSpace>
		);
	}
);

export default Space;
